var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "4 4 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5,18.573c-1.736,0-3.368-0.676-4.596-1.903C5.677,15.442,5,13.81,5,12.073s0.677-3.369,1.904-4.597   c0.391-0.391,1.023-0.391,1.414,0s0.391,1.023,0,1.414C7.468,9.741,7,10.871,7,12.073s0.468,2.333,1.318,3.183   c0.85,0.85,1.979,1.317,3.182,1.317s2.332-0.468,3.182-1.317c0.851-0.85,1.318-1.98,1.318-3.183s-0.468-2.333-1.318-3.183   c-0.391-0.391-0.391-1.023,0-1.414s1.023-0.391,1.414,0C17.323,8.705,18,10.337,18,12.073s-0.677,3.369-1.904,4.597   C14.868,17.897,13.236,18.573,11.5,18.573z M11.5,11c-0.553,0-1-0.448-1-1V5c0-0.552,0.447-1,1-1s1,0.448,1,1v5C12.5,10.552,12.053,11,11.5,11z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.706790eeb67580d0571bd5fad875e552.svg";
export { ForwardRef as ReactComponent };